import {
  to
} from "./chunk.EH2PNIGX.js";
import {
  watch
} from "./chunk.2NT6DI7B.js";
import {
  WebAwesomeElement,
  e,
  n,
  r,
  t
} from "./chunk.LVUMIIKQ.js";
import {
  ke
} from "./chunk.S3625EU6.js";
import {
  __decorateClass
} from "./chunk.SZE6ONST.js";

// src/components/breadcrumb-item/breadcrumb-item.css
var breadcrumb_item_default = ":host {\n  color: var(--wa-color-text-link);\n  display: inline-flex;\n  align-items: center;\n  font: inherit;\n  font-weight: var(--wa-font-weight-action);\n  line-height: var(--wa-line-height-normal);\n  white-space: nowrap;\n}\n\n:host(:last-of-type) {\n  color: var(--wa-color-text-quiet);\n}\n\n.label {\n  display: inline-block;\n  font: inherit;\n  text-decoration: none;\n  color: currentColor;\n  background: none;\n  border: none;\n  border-radius: var(--wa-border-radius-m);\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  transition: color var(--wa-transition-normal) var(--wa-transition-easing);\n}\n\n:host(:not(:last-of-type)) .label:hover {\n  color: color-mix(in oklab, currentColor, var(--wa-color-mix-hover));\n}\n\n:host(:not(:last-of-type)) .label:active {\n  color: color-mix(in oklab, currentColor, var(--wa-color-mix-active));\n}\n\n.label:focus {\n  outline: none;\n}\n\n.label:focus-visible {\n  outline: var(--wa-focus-ring);\n  outline-offset: var(--wa-focus-ring-offset);\n}\n\n.prefix,\n.suffix {\n  display: none;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n}\n\n.prefix,\n.suffix {\n  display: inline-flex;\n  color: var(--wa-color-text-quiet);\n}\n\n::slotted([slot='prefix']) {\n  margin-inline-end: var(--wa-space-s);\n}\n\n::slotted([slot='suffix']) {\n  margin-inline-start: var(--wa-space-s);\n}\n\n:host(:last-of-type) .separator {\n  display: none;\n}\n\n.separator {\n  color: var(--wa-color-text-quiet);\n  display: inline-flex;\n  align-items: center;\n  margin: 0 var(--wa-space-s);\n  user-select: none;\n  -webkit-user-select: none;\n}\n";

// src/components/breadcrumb-item/breadcrumb-item.ts
var WaBreadcrumbItem = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.renderType = "button";
    this.rel = "noreferrer noopener";
  }
  setRenderType() {
    const hasDropdown = this.defaultSlot.assignedElements({ flatten: true }).filter((i) => i.tagName.toLowerCase() === "wa-dropdown").length > 0;
    if (this.href) {
      this.renderType = "link";
      return;
    }
    if (hasDropdown) {
      this.renderType = "dropdown";
      return;
    }
    this.renderType = "button";
  }
  hrefChanged() {
    this.setRenderType();
  }
  handleSlotChange() {
    this.setRenderType();
  }
  render() {
    return ke`
      <span part="prefix" class="prefix">
        <slot name="prefix"></slot>
      </span>

      ${this.renderType === "link" ? ke`
            <a
              part="label"
              class="label label--link"
              href="${this.href}"
              target="${to(this.target ? this.target : void 0)}"
              rel=${to(this.target ? this.rel : void 0)}
            >
              <slot></slot>
            </a>
          ` : ""}
      ${this.renderType === "button" ? ke`
            <button part="label" type="button" class="label label--button">
              <slot @slotchange=${this.handleSlotChange}></slot>
            </button>
          ` : ""}
      ${this.renderType === "dropdown" ? ke`
            <div part="label" class="label label--dropdown">
              <slot @slotchange=${this.handleSlotChange}></slot>
            </div>
          ` : ""}

      <span part="suffix" class="suffix">
        <slot name="suffix"></slot>
      </span>

      <span part="separator" class="separator" aria-hidden="true">
        <slot name="separator"></slot>
      </span>
    `;
  }
};
WaBreadcrumbItem.shadowStyle = breadcrumb_item_default;
__decorateClass([
  e("slot:not([name])")
], WaBreadcrumbItem.prototype, "defaultSlot", 2);
__decorateClass([
  r()
], WaBreadcrumbItem.prototype, "renderType", 2);
__decorateClass([
  n()
], WaBreadcrumbItem.prototype, "href", 2);
__decorateClass([
  n()
], WaBreadcrumbItem.prototype, "target", 2);
__decorateClass([
  n()
], WaBreadcrumbItem.prototype, "rel", 2);
__decorateClass([
  watch("href", { waitUntilFirstUpdate: true })
], WaBreadcrumbItem.prototype, "hrefChanged", 1);
WaBreadcrumbItem = __decorateClass([
  t("wa-breadcrumb-item")
], WaBreadcrumbItem);

export {
  WaBreadcrumbItem
};
